export const HelloNextURL = 'https://dawn-of-edge-testnet.hellonext.co/'
export const GitBook = {
  docs: 'https://edgeprotocol.gitbook.io/edge-protocol/UEVw31jya7YlE6SJEXvW/',
  risk: 'https://edgeprotocol.gitbook.io/edge-protocol/UEVw31jya7YlE6SJEXvW/extras/risks',
  smartContract:
    'https://edgeprotocol.gitbook.io/edge-protocol/UEVw31jya7YlE6SJEXvW/extras/security',
  genesisPool:
    'https://edgeprotocol.gitbook.io/edge-protocol/UEVw31jya7YlE6SJEXvW/genesis-pool',
}
